<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  <main>
    <v-container fluid>
      <v-layout class="tutorial__layout">
        <v-flex xs12>
          <div class="tutorial__layout-card">
            <v-card>
              <v-card-title class="pa-0">
                <div class="top__layout-title">Tutorial</div>
              </v-card-title>
              <v-card-text>
                <span class="title">Video</span>
                <div class="video">
                  <div class="iframe-wrapper">
                    <iframe src="https://drive.google.com/file/d/1OOobo7FuDIvLSNLXOfA7bqnjbKpxom-B/preview" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                  </div>
                </div>
                <span class="title">Figures</span>
                <v-layout row wrap class="mt-3 blue-grey lighten-5" style="border-radius:5px;">
                  <v-flex xs12 md6 class="pl-3 pr-3 pt-2">
                    <img style="width:100%;border-radius:5px;" class="pa-1 white" src="../img/s5.png"/>
                  </v-flex>
                  <v-flex xs12 md6 class="pr-5 pl-3 pt-3 pb-1">
                    <span class="body-2">
                      Flow diagram illustrating the logic for the calculation of the scores, related to STAR Methods.
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2 blue-grey lighten-5" style="border-radius:5px;">
                  <v-flex xs12 md6 class="pl-3 pr-3 pt-2">
                    <img style="width:100%;border-radius:5px;" class="pa-1 white" src="../img/PIK3CB_Snapshot.png"/>
                  </v-flex>
                  <v-flex xs12 md6 class="pr-5 pl-3 pt-3 pb-1">
                    <span class="body-2">
                      Snapshot of the target overview page of the Probe Miner resource for the target PIK3CB.
                    </span>
                    <span class="body-1">
                      As it can be observed the first probe according to the pre-defined weights for the Global Score is pictilisib. However, a red warning highlights lack of 10-fold selectivity. This probe is also covered by The Chemical Probes Portal and it is thus highlighted in a differential blue colour, the expert star rating is displayed and appropriate links to The Chemical Probes Portal are provided to facilitate the navigation between the two resources.
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2 blue-grey lighten-5" style="border-radius:5px;">
                  <v-flex xs12 md6 class="pl-3 pr-3 pt-2">
                    <img style="width:100%;border-radius:5px;" class="pa-1 white" src="../img/ExampleOfHowToUseTheResource_v5.png"/>
                  </v-flex>
                  <v-flex xs12 md6 class="pr-5 pl-3 pt-3 pb-1">
                    <span class="body-2">
                      Probe Miner Resource Documentation on how to use the resource.
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2 blue-grey lighten-5" style="border-radius:5px;">
                  <v-flex xs12 md6 class="pl-3 pr-3 pt-2">
                    <img style="width:100%;border-radius:5px;" class="pa-1 white" src="../img/Documentation_v1_SFig5_v3.jpg"/>
                  </v-flex>
                  <v-flex xs12 md6 class="pr-5 pl-3 pt-3 pb-1">
                    <span class="body-2">
                      Probe Miner Resource Documentation on the Overview page.
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2 blue-grey lighten-5" style="border-radius:5px;">
                  <v-flex xs12 md6 class="pl-3 pr-3 pt-2">
                    <img style="width:100%;border-radius:5px;" class="pa-1 white" src="../img/Documentation_v1_SFig8_v4.jpg"/>
                  </v-flex>
                  <v-flex xs12 md6 class="pr-5 pl-3 pt-3 pb-1">
                    <span class="body-2">
                      Probe Miner Resource Documentation on the customisation of the Global Score.
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2 blue-grey lighten-5" style="border-radius:5px;">
                  <v-flex xs12 md6 class="pl-3 pr-3 pt-2">
                    <img style="width:100%;border-radius:5px;" class="pa-1 white" src="../img/Documentation_v1_SFig6_v2.jpg"/>
                  </v-flex>
                  <v-flex xs12 md6 class="pr-5 pl-3 pt-3 pb-1">
                    <span class="body-2">
                      Probe Miner Resource Documentation on the Chemical Tool Synopsis page.
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2 blue-grey lighten-5" style="border-radius:5px;">
                  <v-flex xs12 md6 class="pl-3 pr-3 pt-2">
                    <img style="width:100%;border-radius:5px;" class="pa-1 white" src="../img/Documentation_v1_SFig7_v2.jpg"/>
                  </v-flex>
                  <v-flex xs12 md6 class="pr-5 pl-3 pt-3 pb-1">
                    <span class="body-2">
                      Probe Miner Resource Documentation on the Chemical Probes Table page.
                    </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
  <prb-footer></prb-footer>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'



import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';

export default {
  components: {
    PrbToolbar,
    PrbTerms,
    PrbFooter
  },
  computed: mapGetters([
    'termsVerified'
  ]),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Tutorial'
  },
  name: 'prbtutorial',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    }
  },
  data() {
    return {
      termsDialog: true,
      search: null,
      e1: 1
    }
  }
}
</script>

<style scoped>
.tutorial__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.tutorial__layout-card {
  padding: 5% 5% 0 5%;
}

.top__layout-title {
  width: 100%;
  font-size: 30px;
  padding: 10px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}

@media screen and (max-width: 1600px) {
  .tutorial__layout-card {
    padding: 2% 2% 0 2%;
  }
}

@media screen and (max-width: 800px) {
  .tutorial__layout-card {
    padding: 2% 0 0 0;
  }
}

.video {
  height: 100%;
  text-align: center;
  padding: 10px 10% 10px 10%;
  box-sizing: border-box;
}
.iframe-wrapper {
  position: relative;
  height: 0;
  padding-top: 56.25%;
  overflow: hidden;
}
.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #455A64;
}
</style>



// WEBPACK FOOTER //
// PrbTutorial.vue?666fd9f4